export const PUBLIC_MODEL_COPY = Object.freeze({
  probability: "Estimate",
  confidence: "Conviction",
});

export function getPublicModelLabel(label, { usePublicCopy, isAdmin } = {}) {
  if (!usePublicCopy || isAdmin) return label;
  if (label === "PWG Probability" || label === "PWG Prob") {
    return PUBLIC_MODEL_COPY.probability;
  }
  if (label === "Confidence") return PUBLIC_MODEL_COPY.confidence;
  return label;
}
